import Jwt from '../helper/interceptors';
import {AppSettings} from '../constants';
import { ObjToParam, MapResponse } from '../helper/helper-api';

export const getHomeOwnerList = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).get(`/api/homeowners/search?${ObjToParam(params.data)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const editHomeOwnerInfo = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).put(`/api/homeowners/${params.userId}`, params.data)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSelectListHomeowner = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false).get(`/api/homeowners/homeowners-select-list?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const searchCurrentAssignedLot = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).get(`/api/homeowners/${params.homeownerId}/lots?${ObjToParam(params.param)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getHomeOwnerProfile = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).get(`/api/homeowners/${params.id}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};




// WEBPACK FOOTER //
// ./src/HomeOwners/api.js